<template>
    <t-form>
        <t-form-item label="隐身模式">
            <t-switch v-model="attribute.isCombinationPageShow" @change="setCombinationPageShow" :label="['开', '关']"
                size="small" />
        </t-form-item>


    </t-form>
</template>

<script>
export default {
    props: {
        attribute: Object,
        cptDataForm: Object,
        currentCpt: Object,
        cacheComponents: Object,
    },
    methods: {
        setCombinationPageShow(flag) {
            let combinationComp = this.cacheComponents.find(item => item.id === this.attribute.combinationCompId)
            if (combinationComp) {
                combinationComp.cptOption.attribute.isCombinationPageShow = flag
            }

        }
    }

}
</script>